import request from '../servises/request'

export function getCouponsList() {
    return request({
        url: '/coupon',
        method: 'GET'
    })
}

export function createCoupon(payload) {
    return request({
        url: '/coupon',
        method: 'POST',
        data: payload
    })
}

export function updateCoupon(data) {
    return request({
        url: `/coupon/${ data.id }`,
        method: 'PATCH',
        data: data
    })
}

export function deleteCoupon(id) {
    return request({
        url: `/coupon/${ id }`,
        method: 'DELETE'
    })
}

export function getPlanGroups() {
    return request({
        url: '/plan/group',
        method: 'GET'
    })
}

export function getPlanTypeByGroup(groupId) {
    return request({
        url: groupId ? `/plan/group-types/${ groupId }` : `/plan/group-types`,
        method: 'GET'
    })
}
